import React, { Component } from "react";
import { BrowserRouter as Router, Switch, Route } from "react-router-dom";

import Home from "./pages/Home/Home";
import SignUp from "./pages/SignUp/SignUp";
import SignIn from "./pages/SignIn/SignIn";
import FreeVideos from "./pages/FreeVideos/FreeVideos";
import Courses from "./pages/Courses/Courses";
import CourseDetail from "./pages/Courses/CourseDetail";
import Gallery from "./pages/Gallery/Gallery";
import Contact from "./pages/Contact/Contact";
import About from "./pages/About/About";
import Resources from "./pages/Resources/Resources";
import Policies from "./pages/Policies/Policies";

class Connector extends Component {
  render() {
    return (
      <Router>
        <Switch>
          <Route path="/" exact>
            <Home />
          </Route>
          <Route path="/sign-up" exact>
            <SignUp />
          </Route>
          <Route path="/sign-in" exact>
            <SignIn />
          </Route>
          <Route path="/free-videos" exact>
            <FreeVideos />
          </Route>
          <Route path="/courses" exact>
            <Courses />
          </Route>
          <Route path="/courses/:id" component={CourseDetail} />
          <Route path="/gallery" exact>
            <Gallery />
          </Route>
          <Route path="/contact" exact>
            <Contact />
          </Route>
          <Route path="/about" exact>
            <About />
          </Route>
          <Route path="/resources" exact>
            <Resources />
          </Route>
          <Route path="/privacy" exact>
            <Policies doc="privacy" />
          </Route>
          <Route path="/terms" exact>
            <Policies doc="terms" />
          </Route>
        </Switch>
      </Router>
    );
  }
}

export default Connector;
